import { useState } from "react";
import { NavLink } from "react-router-dom";
import { FiMenu, FiX, FiFacebook, FiInstagram, FiYoutube } from "react-icons/fi";

const NavbarDumai = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="w-full fixed top-0 left-0 z-50 font-signika">
      {/* ================= TOPBAR ================= */}
      <div className="hidden md:flex justify-between items-center bg-gray-100 text-gray-600 text-sm px-6  py-2 ">
        <div className="flex items-center gap-6">
          <span>📞 0895352380652</span>
          <span>✉️ hijafera@gmail.com</span>
        </div>

        <div className="flex items-center gap-3">
          <span className="mr-2">Follow Us On:</span>
          <FiFacebook className="cursor-pointer" />
          <FiInstagram className="cursor-pointer" />
          <FiYoutube className="cursor-pointer" />
        </div>
      </div>

      {/* ================= MAIN NAVBAR ================= */}
      <div className="bg-white shadow-sm">
        <div className=" px-4 md:px-6 lg:px-10 h-[74px] flex items-center justify-between">
          {/* LOGO */}
          <NavLink to="/" className="flex items-center gap-3">
            <img src="/images/logo.png" alt="Dumai" className="h-14 md:h-14 object-contain" />
          </NavLink>

          {/* MENU DESKTOP */}
          <nav className="hidden lg:flex items-center gap-8 text-gray-700 font-medium">
            <NavLink to="/" className="hover:text-primary">
              Beranda
            </NavLink>
            <NavLink to="/produk" className="hover:text-primary">
              Produk
            </NavLink>
            <NavLink to="/tentang" className="hover:text-primary">
              Tentang Kami
            </NavLink>

            <NavLink to="/faq" className="hover:text-primary">
              FAQ
            </NavLink>
          </nav>

          {/* RIGHT BUTTON */}
          <div className="hidden lg:flex items-center gap-4">
            <NavLink to="/login/affiliate" className="bg-primary hover:bg-purple-600 text-white px-6 py-2.5 rounded-full font-semibold transition">
              Masuk
            </NavLink>
            <NavLink to="/register/affiliate" className="border border-primary hover:bg-purple-600 hover:text-white text-primary px-6 py-2.5 rounded-full font-semibold transition">
              Gabung Affiliate
            </NavLink>
          </div>

          {/* HAMBURGER */}
          <button className="lg:hidden" onClick={() => setOpen(!open)}>
            {open ? <FiX size={28} /> : <FiMenu size={28} />}
          </button>
        </div>
      </div>

      {/* ================= MOBILE MENU ================= */}
      <div className={`lg:hidden fixed top-[74px] left-0 w-full bg-white shadow-md transition-all duration-300 ${open ? "max-h-screen py-6" : "max-h-0 overflow-hidden"}`}>
        <div className="flex flex-col items-center gap-5 text-gray-700 font-medium">
          <NavLink to="/" onClick={() => setOpen(false)}>
            Beranda
          </NavLink>
          <NavLink to="/produk" onClick={() => setOpen(false)}>
            Produk
          </NavLink>
          <NavLink to="/tentang" onClick={() => setOpen(false)}>
            Tentang Kami
          </NavLink>

          <NavLink to="/faq" onClick={() => setOpen(false)}>
            FAQ
          </NavLink>

          <NavLink to="/login/affiliate" className="bg-primary text-white px-6 py-2 rounded-full" onClick={() => setOpen(false)}>
            Masuk
          </NavLink>
          <NavLink to="/register/affiliate" className="border border-primary text-primary px-6 py-2 rounded-full" onClick={() => setOpen(false)}>
            Gabung Affiliate
          </NavLink>
        </div>
      </div>
    </header>
  );
};

export default NavbarDumai;
